import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			funnel: {
				id: 'ob-female-walking-summary-checkpoints',
				locale: ['en'],
			},
		},
	},
]

export default config
